import {execute_with_consent} from "@plaudit/analytics-integrations-api";

function handleBodyLevelReferrerAffiliateId() {
	const refer_affiliate_id = document.body.getAttribute("data-refer-affiliate-id") ?? "";
	if (!refer_affiliate_id) {
		return;
	}

	const existing_refer_affiliate_id = /refer_affiliate_id=([^;]+);/.exec(document.cookie)?.groups?.[1] ?? "";
	if (refer_affiliate_id !== existing_refer_affiliate_id) {
		// This cookie lasts for 30 days
		document.cookie = `refer_affiliate_id=${refer_affiliate_id};max-age=2592000;path=/;SameSite=Lax`;
		setTimeout(() => window.location.reload(), 1_000);
	}
}

execute_with_consent({
	categories: ['functional'],
	allowed() {
		if (document.body) {
			handleBodyLevelReferrerAffiliateId();
		} else {
			document.addEventListener('DOMContentLoaded', handleBodyLevelReferrerAffiliateId);
		}
	}
});
